
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import * as moment from "moment";
  // import CardEtatEmp from "./CardEtatEmp.vue";
  import EtatAddEdit from "./EtatAddEdit.vue";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import SearchAndFilter from "@/views/still/search_and_filters.vue";
  import { useRouter } from "vue-router";
   
  export default defineComponent({
    name: "General",
    components : {
        EtatAddEdit,
        SearchAndFilter
    },
    setup() {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        mylist : {} as any,
        EtatAddEdit : 0,
        openCloseEtatAddEdit : 0,
        loading : true,
        initialMyList: {} as any,
        search : 0,
    });

    const tableFilters = ref([]) as any;

    const router = useRouter();

    onMounted(() => {
      setCurrentPageBreadcrumbs("Etat mensuel", ["Pages", "Profile"]);

      console.log('list', state.mylist.eem_emp_prenom_nom);

      tableFilters.value.push({ name: "Collaborateur", key: "emp_prenom_nom", label: "emp_prenom_nom" });
      tableFilters.value.push({ name: "Statut", key: "eem_status", label: "eem_status" });
      refresh();

      if (router.currentRoute.value.params.otherparam) {
        openEtatEmp(Number(router.currentRoute.value.params.otherparam));
      } 

      state.loading = false;

    });

      const toDate = (d) => {
        return moment.default(d).format("DD.MM.YYYY");
      };


      const openEtatEmp = (id = 0) =>{
        state.EtatAddEdit = id;
        state.openCloseEtatAddEdit = 1;
      }


      const SearchAndFilter = ref(null);


      const refresh = async (update = false, idEtat = 0) => {
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/getAllEtatEmp");
        if (!update) {
          state.mylist = getEtatEmp.results;
          state.initialMyList = state.mylist;

          console.log('list', state.mylist);
        } else {
          (SearchAndFilter.value as any).searchAllItems("", getEtatEmp.results);
        }


      };
     
      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          toDate,
          openEtatEmp,
          refresh,
          tableFilters,
          SearchAndFilter
      };
    },
  });
  